/* global G */
import { debounce, def } from 'lib/util'
import { findPosition } from 'platform/adapter/cart/helper'

/**
 * Changes a property inside the current cart. This can either be a position, or a root property,
 * like `recipientData`. If `remote` is false, it will not persist the cart to the server and just
 * update the local one.
 *
 * Dispatches `G.CART, G.SET` event afterward.
 *
 * @param {Gaia.Web.Application} app  the Platform Web Application
 * @returns {AttachmentEventListener}  an AttachmentEventListener
 */
const fn = app => async ({ detail = null } = {}) => {
  const { key, name, data, remote = true } = detail[G.DATA]

  const adapter = app[G.ADAPTER][G.CART]
  const activeCart = adapter[G.DATA]
  const eventBus = app[G.ADAPTER][G.EVENTS]

  const parsedData = Object.keys(data).reduce(
    (acc, x) => ({ ...acc, [x]: def(data[x]?.value) ? data[x]?.value : data[x] }), {},
  )

  if (!key && !name) {
    activeCart.value = {
      ...activeCart.value,
      ...parsedData?.value ? parsedData.value : parsedData,
    }
  }

  if (key || name) {
    activeCart.value.positions = activeCart.value.positions.map(position => (
      findPosition([position], { key, name })
        ? { ...position, ...parsedData }
        : position))
  }

  eventBus.dispatch(eventBus.type(G.CART, remote ? G.SET : G.DONE), { [G.DATA]: activeCart })
}

export default app => debounce(fn(app), 300, false)
